import { __assign, __makeTemplateObject, __rest } from "tslib";
import React from 'react';
import { styled } from '../../../foundation';
import { RcIcon } from '../../Icon';
var _StyledIconAvatar = function (_a) {
    var size = _a.size, rest = __rest(_a, ["size"]);
    return React.createElement(RcIcon, __assign({ size: "inherit" }, rest));
};
export var StyledIconAvatar = styled(_StyledIconAvatar)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-size: ", "px;\n"], ["\n  font-size: ", "px;\n"])), function (_a) {
    var size = _a.size;
    return size;
});
var templateObject_1;
